// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_parallax.styl
// module id = 171
// module chunks = 0